import { useEffect, useState } from 'react'
import { Content, InputWrapper } from './styles'
import { useGame, useGameWrapper } from '../../../contexts'
import { getAssetUrl } from '../../../utils/assets_helpers'
import { makePostMissionAnswer, makePostMissionPassword, makePutMissionAnswer } from '../../../../main/usecases/mission-answer/post-mission-answer-factory'
import { addAllowFullScreen, replaceInstructionsTags } from '../../../utils/mission_helpers'
import { Instructions, Container, Image } from '../styles'
import { addLocalStorage, getLocalStorage } from '../../../utils/storage_helpers'
import { getTeam } from '../../../utils/team_helpers'
import { t } from '../../../adapters/translate/translate'
import { replaceHtmlEntity } from '../../../utils/text_replace'

const SimpleTextMission = () => {
  const [instructions, setInstructions] = useState<string|null>('')
  const [password, setPassword] = useState<any>(null)
  const [wrongPassword, setWrongPassword] = useState<any>(null)
  const { timeout, currentMission, doSubmit, submitButtonIsEnabled, submitCallback, handleToggleStatusSubmitButton, setTimePaused } = useGameWrapper()
  const [color, setColor] = useState<any>('#fff')
  const team = getTeam()
  const { game } = useGame()

  async function sendAnswer () {
    try {
      const resPost = await makePostMissionAnswer().post({
        mission: currentMission?.uuid,
        team: team.id
      })

      return await makePutMissionAnswer(resPost['@id'] || '').update({
        answer: [{ description: password }],
        status: timeout ? 'timeout' : 'responded'
      })
    } catch (error) {
      console.error('SimpleTextMission.sendAnswer', error)
    }
  }

  async function sendPassword () {
    try {
      if (currentMission) {
        const res = await makePostMissionPassword(currentMission?.uuid).update({
          password: password
        })

        const resPassword = {
          password: password,
          correct: res?.correctPassword,
          uuid: currentMission?.uuid,
          status: 'responded'
        }

        addLocalStorage('passwordTemp', JSON.stringify(resPassword))

        if (res?.correctPassword) {
          const localAnswers = JSON.parse(getLocalStorage('localAnswers') || '[]')
          addLocalStorage('localAnswers', JSON.stringify([
            ...localAnswers,
            resPassword
          ]))
        }
        return resPassword
      }
    } catch (error) {
      console.error('SimpleTextMission.sendAnswer', error)
    }
  }

  function handleEnableButton () {
    if (!currentMission?.options?.hasPassword || password?.trim().length > 0) {
      handleToggleStatusSubmitButton(true)
    } else {
      handleToggleStatusSubmitButton(false)
    }
  }

  useEffect(() => {
    handleEnableButton()
  }, [password])

  useEffect(() => {
    if (!currentMission) return
    const formattedInstructions = replaceInstructionsTags({ mission: currentMission, points: currentMission.pointsIfCorrect })
    setInstructions(addAllowFullScreen(formattedInstructions))
  }, [currentMission])

  useEffect(() => {
    if (doSubmit && submitButtonIsEnabled) {
      if (team) {
        submitCallback(sendAnswer)
      } else if (currentMission?.options?.hasPassword) {
        submitCallback(sendPassword)
      }
    }
  }, [doSubmit, submitButtonIsEnabled])

  useEffect(() => {
    setTimePaused(false)
    if (game) { setColor(game?.textColor || '#fff') }
  }, [game])

  useEffect(() => {
    if (timeout) {
      submitCallback(sendAnswer)
    }
  }, [timeout])

  useEffect(() => {
    const div = document.getElementById('instructions')
    if (div) {
      div.innerHTML = replaceHtmlEntity(div.innerHTML)
    }
  }, [instructions])

  return (
    <Container justify="center">
      { currentMission?.icon && <Image src={getAssetUrl('icon', String(currentMission?.icon))} /> }
      <Content>
        {!!instructions && <Instructions id="instructions" dangerouslySetInnerHTML={
          { __html: instructions }
        }/>}

      {currentMission?.options?.hasPassword &&
        <InputWrapper>
          <label style={{ color }}>Digite a senha para prosseguir:<span>*</span></label>
          <input
            value={password}
            placeholder={t('Enter here')}
            type='password'
            onChange={(e) => {
              setWrongPassword(false)
              setPassword(e.target.value)
            }}
          />
          {wrongPassword && <small>{t('Wrong password')}</small>}
        </InputWrapper>}
      </Content>
    </Container>
  )
}

export default SimpleTextMission
